<div id="app-root-container"  *ngIf="!isMobile ">
  <div class="header" *ngIf="loginDisplay">
    <div class="cursor" (click)="navigateToInquiryPage()"><div class="logo-s mr10"></div><div class="logoTitle">{{'appName' | translate }}</div></div>
    <app-user-info *ngIf="loginDisplay"></app-user-info>
  </div>
  <nz-modal [(nzVisible)]="isTermsAndConditionsVisible" [nzFooter]="null" [nzWidth]="1200" (nzOnCancel)="handleTermsAndConditionsClose()">
    <ng-container *nzModalContent>

      <div class="loginImage"></div>

      <h1 nz-typography>TERMS OF USE FOR VOCATIONAL TRAINING COUNCIL (VTC) VIRTUAL DESKTOP SERVICES</h1>

      <h2 nz-typography>1. ACCEPTANCE OF TERMS</h2>
      
      <p>
      Welcome to the Vocational Training Council (VTC) Virtual Desktop Services. The Service, which includes access to virtual desktops and related websites, is provided to support the educational mission of VTC. By accessing and using the Service, you acknowledge that you have read, understood, and agree to comply with the terms and conditions outlined herein. Furthermore, you are subject to any posted guidelines or rules applicable to such services, which may be posted and modified from time to time.
      </p>
      <p>
      If you do not accept these Terms of Use in their entirety, you must not access or use the Service. VTC reserves the right to modify these Terms of Use at any time, with the amended terms becoming effective upon posting. Your continued use of the Service following such modifications constitutes your acceptance of the new terms.
      </p>
      
      <h2 nz-typography>2. PRIVACY POLICY</h2>
      
      <p>
      Our Privacy Policy details the handling of personal data collected from you or provided by you in connection with the use of the Service. By using the Service, you consent to the processing of your personal data in accordance with the Privacy Policy and affirm the accuracy of the data you provide.
      </p>
      
      <h2 nz-typography>3. ELIGIBILITY AND EDUCATIONAL PURPOSE</h2>
      
      <p>
      The Service is intended exclusively for educational purposes, supporting VTC's mission to facilitate learning and teaching. Users must be of legal age to consent to data processing in Hong Kong or have obtained parental or guardian consent if under the required age. The Service is not available to users who have been suspended or removed by VTC for any reason. <span style="margin: 0px; color: rgb(237, 125, 49);">Users shall avoid any wasteful use of VTC IT resources.</span>
      </p>
      
      <h2 nz-typography>4. USER CONDUCT</h2>
      
      <p>
      In alignment with the educational purpose of the Service, users are expected to conduct themselves in a responsible and lawful manner. Users are prohibited from engaging in actions that:
      </p>
      <ul>
        <li>
          Infringe on the intellectual property or privacy rights of others.
        </li>
        <li>
          Involve the uploading, posting, or transmission of any content that is unlawful or objectionable.
        </li>
        <li>
          Harm minors or impersonate any person or entity.
        </li>
        <li>
          Manipulate identifiers or misrepresent the origin of content.
        </li>
        <li>
          Violate any local, state, national, or international laws.
        </li>
      </ul>

      <h2 nz-typography>5. INTELLECTUAL PROPERTY RIGHTS</h2>
      
      <p>
      All content on the Service, including but not limited to text, graphics, logos, and software, is owned by VTC or its content suppliers and is protected under Hong Kong copyright laws and international treaties. Use of the content in a manner not expressly authorized by these Terms of Use is strictly prohibited.
      </p>
      
      <h2 nz-typography>6. LIMITATION OF LIABILITY</h2>
      
      <p>
      The Service is provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind. VTC disclaims all warranties to the extent permitted by law, including the implied warranties of merchantability and fitness for a particular purpose. VTC shall not be liable for any damages resulting from the use of the Service.
      </p>
      
      <h2 nz-typography>7. INDEMNIFICATION</h2>
      
      <p>
      You agree to indemnify and hold harmless VTC and its affiliates from any claims arising out of your breach of these Terms of Use or your use of the Service.
      </p>
      
      <h2 nz-typography>8. GOVERNING LAW AND COPYRIGHT COMPLIANCE</h2>
      
      <p>
      These Terms of Use shall be governed by the laws of Hong Kong. The Service complies with Hong Kong copyright laws, and users are expected to adhere to these laws when accessing the Service.
      </p>
      
      <h2 nz-typography>9. CHANGES TO TERMS OF USE</h2>
      
      <p>
      VTC may revise these Terms of Use at any time. It is your responsibility to review them regularly. Continued use of the Service after changes have been made signifies your acceptance of the revised terms.
      </p>
      
      <h2 nz-typography>10. CONTACT INFORMATION</h2>
      
      <p>
      For any questions regarding these Terms of Use, please contact us at <a href="mailto:vdi-helpdesk@stu.vtc.edu.hk">vdi-helpdesk@stu.vtc.edu.hk</a>.
      </p>
      
      <p>By accessing and using the VTC Virtual Desktop Services, you acknowledge that you have read these terms, understand them, and agree to be bound by them.
      </p>
      
      <p>Last updated on 19 March 2024</p>
    </ng-container>
  </nz-modal>

  <nz-modal [(nzVisible)]="isCookieWarningVisible" [nzTitle]="'Cookie Settings Required'" [nzWidth]="600" (nzOnCancel)="handleCookieWarningClose()" [nzOkText]="'I Understand'" (nzOnOk)="handleCookieWarningClose()">
    <ng-container *nzModalContent>
      <div style="padding: 20px;">
        <h3 nz-typography style="color: #ed7d31; margin-bottom: 16px;">
          <span nz-icon nzType="warning" style="margin-right: 8px;"></span>
          Third-Party Cookies Required
        </h3>
        <p nz-typography>
          Your browser appears to be blocking third-party cookies from <strong>login.microsoftonline.com</strong>.
          This prevents the application from authenticating you silently.
        </p>
        <p nz-typography>
          <strong>To fix this issue:</strong>
        </p>
        <ul style="margin-left: 20px;">
          <li><strong>Chrome:</strong> Settings > Privacy and security > Third-party cookies > Sites that can use third-party cookies > Add <code>login.microsoftonline.com</code></li>
          <li><strong>Firefox:</strong> Settings > Privacy & Security > Cookies and Site Data > Manage exceptions > Add <code>login.microsoftonline.com</code></li>
          <li><strong>Edge:</strong> Settings > Cookies and site permissions > Manage cookies and site data > Allow > Add <code>login.microsoftonline.com</code></li>
          <li><strong>Safari:</strong> Settings > Privacy > Manage Website Data > Add <code>login.microsoftonline.com</code></li>
        </ul>
        <p nz-typography style="margin-top: 16px; color: #666;">
          After enabling cookies, please refresh the page and try logging in again.
        </p>
      </div>
    </ng-container>
  </nz-modal>
  <nz-layout *ngIf="loginDisplay">
    <nz-sider nzCollapsible [nzCollapsed]="isCollapsed" nzWidth="200px"  (mousemove)="mousemoveFunction()" (mouseleave)="mouseleaveFunction()">
      <div class="nothing"></div>
      <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isMenuCollapsed">
        <li nz-submenu nzTitle="{{'menu.helpdesk' | translate}}" nzIcon="appstore">
          <ul>
            <li nz-menu-item><a routerLink="/inquiry" routerLinkActive="active" ariaCurrentWhenActive="page">
              <span>{{'menu.enquiry' | translate}}</span>
            </a></li>
            <li nz-submenu nzTitle="{{'menu.adminPage' | translate}}" *ngIf="isShowRole">
              <ul>
                <li nz-menu-item routerLink="/category">{{'menu.categorySetup' | translate}}</li>
                <li nz-menu-item routerLink="/subcategory">{{'menu.subCategorySetup' | translate}}</li>
                <li nz-menu-item routerLink="/support">{{'menu.supportTeam' | translate}}</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </nz-sider>
    <nz-layout>
      <nz-content>
        <div class="content" >
          <div class="contentInfo">
            <router-outlet></router-outlet>
          </div>
        </div>
      </nz-content>
    </nz-layout>
  </nz-layout>
  <nz-layout *ngIf="isTicket">
    <nz-layout  style="overflow-y: auto;">
        <router-outlet></router-outlet>
    </nz-layout>
  </nz-layout>
  <div class="login" *ngIf="!isTicket && !loginDisplay && !isLoginRedirecting">
    <header>
      <app-lang></app-lang>
    </header>
      <section>
          <div class="loginTitle">{{'appName' | translate }}</div>
          <div class="loginImage"></div>
          <div class="loginBtn">
            <button mat-raised-button color="primary" class="w240"  (click)="login()"> {{'login.button' | translate }}</button>
          </div>
          <div class="termsAndConditionsBtn">
            <button nz-button nzSize="small" nzDanger (click)="showTermsAndConditionsModal()"> {{'login.declare' | translate}}</button>
          </div>

      </section>
      <footer class="mt80">
          <a>{{ 'footer' | translate }}</a>
      </footer>
    </div>
</div>

<div *ngIf="isMobile">
  <nz-layout *ngIf="isTicket">
      <router-outlet></router-outlet>
  </nz-layout>
  <div class="login" *ngIf="!isTicket && !loginDisplay && !isLoginRedirecting">
    <header>
      <app-lang></app-lang>
    </header>
      <section>
          <div class="loginTitle">{{'appName' | translate }}</div>
          <div class="loginImage"></div>
          <div class="loginBtn">
          <button mat-raised-button color="primary" class="w240"  (click)="login()"> {{'login.button' | translate }}</button>
          </div>
          <div class="termsAndConditionsBtn">
          <button nz-button nzSize="small" nzDanger (click)="showTermsAndConditionsModal()"> {{'login.declare' | translate}}</button>
          </div>
      </section>
      <footer class="mx">
          <a>{{ 'footer' | translate }}</a>
      </footer>
    </div>
  <div class="header mobileHeader" *ngIf="!isTicket && loginDisplay">
    <div class="logo-s logoMobile"></div>
    <app-user-info [isShowRole]="isShowRole" *ngIf="loginDisplay"></app-user-info>
  </div>
  <router-outlet *ngIf="!isTicket && loginDisplay"></router-outlet>
</div>
